import { simpleSet } from '@r/reducers/utils';

const setSingletonCabinetJsonModalOpen = simpleSet as
  redux.reducers.flags.singletonCabinetJsonModalOpen;

export const singletonCabinetJsonModalOpen = setSingletonCabinetJsonModalOpen(
  'SET_SINGLETON_CABINET_JSON_MODAL_OPEN',
  false
);
